import { render, staticRenderFns } from "./PlantContratoExport.vue?vue&type=template&id=296264b4"
import script from "./PlantContratoExport.vue?vue&type=script&lang=js"
export * from "./PlantContratoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports